var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHealthcare(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.9535,
    cy: 22.9535,
    r: 22.9535,
    fill: "#EFF5FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_422_727)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.206 21.9752H24.8364V17.4026H22.5764V21.9752H18.2068V24.1632H22.5764V28.7362H24.8364V24.1632H29.206V21.9752Z",
    fill: "#FFCA00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7061 33.9825H24.0811V33.9758C29.9199 33.7772 34.6082 28.9609 34.6082 23.0689C34.6082 17.0517 29.7183 12.156 23.7061 12.156C17.6939 12.156 12.8044 17.0517 12.8044 23.0693C12.8044 29.0869 17.6939 33.9825 23.7061 33.9825ZM14.0101 23.0693C14.0101 17.7169 18.3603 13.3622 23.7061 13.3622C29.0519 13.3622 33.4025 17.7169 33.4025 23.0693C33.4025 28.4217 29.0519 32.7763 23.7061 32.7763C18.3603 32.7763 14.0101 28.4217 14.0101 23.0693Z",
    fill: "#2176FF",
    stroke: "#2176FF",
    strokeWidth: 0.75
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_422_727"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.0146,
    height: 22.6423,
    fill: "white",
    transform: "translate(11.6644 11.6642)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthcare);
export default __webpack_public_path__ + "static/media/healthcare.55866a13fccb145df7348a4e42c4bb2f.svg";
export { ForwardRef as ReactComponent };